import { useEffect } from 'react';

import { allowScroll, preventScroll } from './usePreventScroll.utils';

const usePreventScroll = (isActive: boolean = true) => {
  useEffect(() => {
    if (isActive) preventScroll();

    return () => {
      if (isActive) allowScroll();
    };
  }, [isActive]);
};

export default usePreventScroll;
